import React from "react";
import "./login.css";

function Login() {
  return (
    <div className="login__container">
      <div>
        <p>Acceso interno deshabilitado.</p>
      </div>
    </div>
  );
}

export default Login;
